import { Plus } from 'lucide-react';
import type { ReactElement } from 'react';
import type { FaqItem } from './faq-items';

interface QuoteFaqItemProps {
  readonly item: FaqItem;
}

/**
 * 질문 한 줄 — 네이티브 details/summary 로 펼친다(키보드·보조기기의 펼침 상태를 브라우저가 알린다).
 * 펼치면 더하기 표시가 45도 돌아 닫기 모양이 된다.
 */
export const QuoteFaqItem = ({ item }: QuoteFaqItemProps): ReactElement => (
  <li className="border-b border-foreground/15">
    <details className="group">
      <summary className="flex cursor-pointer list-none items-center justify-between gap-6 py-6 text-left text-[17px] font-semibold tracking-[-0.02em] sm:text-lg [&::-webkit-details-marker]:hidden">
        <span>{item.question}</span>
        <Plus
          aria-hidden
          strokeWidth={1.75}
          className="size-5 shrink-0 transition-transform group-open:rotate-45"
        />
      </summary>
      <p className="max-w-3xl pb-6 text-[15px] leading-relaxed text-muted-foreground">
        {item.answer}
      </p>
    </details>
  </li>
);
